import { render, staticRenderFns } from "./EmployeeSummaryItem.vue?vue&type=template&id=2e68891a&scoped=true&lang=pug"
import script from "./EmployeeSummaryItem.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryItem.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSummaryItem.vue?vue&type=style&index=0&id=2e68891a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68891a",
  null
  
)

export default component.exports